/**
 * Copyright (c) NCR Terafina
 **/

import TagManager from 'react-gtm-module';
export interface Properties {
  [x: string]: any;
}
/**
 * Analytics Service to use with GTM
 *
 */
export const AnalyticsService = {
  track(data: Properties) {
    TagManager.dataLayer({
      dataLayer: {
        ...data,
      },
    });
  },
  trackPageView(name: string, title: string) {
    TagManager.dataLayer({
      dataLayer: {
        event: 'Page View',
        pagePath: name,
        'content-name': name,
        pageTitle: title,
      },
    });
    return;
  },
  initialize() {
    const tagManagerArgs = {
      gtmId: 'GTM-NVCGPF3',
    };
    TagManager.initialize(tagManagerArgs);
    return;
  },
};
